import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef} from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Person } from './model/person';
import { Personorg } from './model/personorg';
import { RegistrationUser } from './model/registrationuser';
import { OrguseraddService } from './service/orguseradd.service';
import { Auth } from 'aws-amplify';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orguseradd',
  templateUrl: './orguseradd.component.html',
  styleUrls: ['./orguseradd.component.css']
})
export class OrguseraddComponent implements OnInit {
  errorMessage:string;
  registrationUser:RegistrationUser;
  showSuccess:boolean;
  formIsValid:boolean;
  @Output() userfieldValidator:boolean = false;
  @Output() emailfieldValidator:boolean = false;
  @Output() memberToAdd = new EventEmitter<Personorg>();
  @Output() showSpinner:boolean;
  @ViewChild("closemodal", { static: true }) closemodal: ElementRef;
  
  constructor(private orguserservice:OrguseraddService) { }

  ngOnInit() {
    this.showSpinner = false;
    this.registrationUser = new RegistrationUser;
    this.showSuccess = false;
    this.formIsValid = false;
    
  }
  resetModal(){

    this.showSpinner = false;
    this.errorMessage = undefined;
    this.registrationUser = new RegistrationUser;
    this.showSuccess = false;
    this.formIsValid = false;
  }
  checkForm(){
    if(this.registrationUser.username.match(/^[a-z0-9]+$/i) 
      && this.registrationUser.email.match(/^[a-z0-9]+$/i)){
      this.formIsValid = true;
    }else{
      this.formIsValid = false;
    }
  }

  onUsernameChange(value){
    if(!value.includes('/')){
      this.formIsValid = true;
      this.userfieldValidator = true;
    }else{
      this.formIsValid = false;
      this.userfieldValidator = false;
    }
  }
  onEmailChange(value){
    if(!value.includes('/')){
      this.formIsValid = true;
      this.emailfieldValidator = true;
    }else{
      this.emailfieldValidator = false;
    }
  }

  create(){
      this.showSpinner = true;
      this.errorMessage = null;
      // Create person
      let person:Person = {
        personId: "username:"+this.registrationUser.username,
        fullname: this.registrationUser.name,
        title: this.registrationUser.jobtitle,
        email: this.registrationUser.email
      }
      this.orguserservice.addPerson(person.personId,person).pipe(untilDestroyed(this)).subscribe(pers =>{
        // Create personOrg joiner
        let orglist:Personorg[] = JSON.parse(SessionHelper.getPersonOrgs());
        let currentOrg = orglist.find(o => o.organizationId === SessionHelper.getChoosenOrg());
        //console.log('currentOrg',currentOrg);
        //console.log('orglist',orglist);
        let persorg:Personorg = {
          organizationId: SessionHelper.getChoosenOrg(),
          organization: currentOrg.organization,
          membername: this.registrationUser.name,
          personId: pers.personId,
          member_function: this.registrationUser.jobtitle,
          email: this.registrationUser.email,
          professionaldesc: '-',
          im: '-',
          address: '-',
          address2: '-',
          zip: '-',
          city: '-',
          phone: '-',
          avatarurl: '-',
          sendinvite: this.registrationUser.invite,
          username: this.registrationUser.username
        } 
        this.orguserservice.createPersonOrg(persorg).pipe(untilDestroyed(this)).subscribe(result => {
          // Accept joiner
          //.log('accept joiner',persorg);
          this.orguserservice.makeMember(persorg,SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(result => {
            //TODO add member to list
            //console.log('creation successful');
            //this.memberToAdd.emit(persorg);
            //persorg = new Personorg;
            this.registrationUser = new RegistrationUser;
        
            setTimeout(() => {
              this.showSpinner = false;
              setTimeout(() => {
                this.showSuccess = true;
                this.closemodal.nativeElement.click();
              }, 100);
            }, 100);
            

          });

        });

        
      });

      }
      orguseraddsendemail(){
        this.registrationUser.invite =! this.registrationUser.invite;
      }
}
